import { render, staticRenderFns } from "./PromoProductsSelect.vue?vue&type=template&id=5929cdcf&"
import script from "./PromoProductsSelect.vue?vue&type=script&lang=js&"
export * from "./PromoProductsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports